import React from 'react';
import TagInput from '../inputs/TagInput';
import MultiSelectGrid from '../inputs/MultiSelectGrid';
import { SENIORITY_OPTIONS, FUNCTIONAL_OPTIONS } from '../../../constants/peakyLeadsOptions';

const PersonFilters = ({ filters, onFilterChange }) => {
  return (
    <>
      <TagInput
        label="Job Titles"
        value={filters.person_title}
        onChange={(value) => onFilterChange('person_title', value)}
        placeholder="e.g., CEO, Marketing Manager (Press Enter to add)"
        maxTags={100}
        hint="Add up to 100 job titles. Press Enter after each title."
      />

      <MultiSelectGrid
        label="Seniority Levels"
        options={SENIORITY_OPTIONS}
        value={filters.seniority}
        onChange={(value) => onFilterChange('seniority', value)}
        minWidth="120px"
        hint="Select one or more seniority levels"
      />

      <MultiSelectGrid
        label="Functional Departments"
        options={FUNCTIONAL_OPTIONS}
        value={filters.functional}
        onChange={(value) => onFilterChange('functional', value)}
        minWidth="160px"
        hint="Select one or more functional departments"
      />
    </>
  );
};

export default PersonFilters;
